export const PERSONAL_LOGIN_PATH = '/login';
export const ADVISOR_LOGIN_PATH = '/advisor-login';

export type LoginVariant = 'personal' | 'advisor';

export function resolveLoginPath(accountType?: string | null): string {
  return accountType === 'B' ? ADVISOR_LOGIN_PATH : PERSONAL_LOGIN_PATH;
}

export function isBusinessSession(): boolean {
  if (localStorage.getItem('accountType') === 'B') {
    return true;
  }

  return !!(
    sessionStorage.getItem('clocr_buser') ||
    localStorage.getItem('businessUser')
  );
}

export function isBusinessAuthRoute(path: string): boolean {
  const normalized = (path || '').split('?')[0].toLowerCase();
  return (
    normalized.startsWith('/business-dashboard') ||
    normalized.startsWith('/business-onboarding') ||
    normalized.startsWith('/business/')
  );
}

export function resolvePostLogoutLoginPath(): string {
  return isBusinessSession() ? ADVISOR_LOGIN_PATH : PERSONAL_LOGIN_PATH;
}

export function resolveUnauthenticatedLoginPath(url?: string): string {
  if (isBusinessSession() || (url && isBusinessAuthRoute(url))) {
    return ADVISOR_LOGIN_PATH;
  }

  return PERSONAL_LOGIN_PATH;
}

export function isAdvisorLoginPath(path: string): boolean {
  const normalized = (path || '').split('?')[0].toLowerCase();
  return normalized === ADVISOR_LOGIN_PATH || normalized.startsWith(`${ADVISOR_LOGIN_PATH}/`);
}

export function isPersonalLoginPath(path: string): boolean {
  const normalized = (path || '').split('?')[0].toLowerCase();
  return normalized === PERSONAL_LOGIN_PATH || normalized.startsWith(`${PERSONAL_LOGIN_PATH}/`);
}

export function isPublicLoginPath(path: string): boolean {
  return isPersonalLoginPath(path) || isAdvisorLoginPath(path);
}
